export function convertAccountsToMap(accounts) {
    if (!accounts) return {};

    return accounts.reduce((acc, account) => {
        acc[account.accountNumber] = account;
        return acc;
    }, {});
}
